import React from 'react';
import classNames from 'classnames/bind';

// Components
import { Text } from '@beef/ui-kit';
import { Icon } from 'components';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const Heading = ({ children, title, refresh, className }) => (
  <div className={cx('heading-wrapper')}>
    <div className={cx('title-wrapper', className)}>
      <Text tagType="h1" size="size1-b">{title}</Text>
      {refresh && <Icon className={cx('heading-refresh')} name="refresh" />}
    </div>
    {children}
  </div>
);

export default Heading;
